/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IRewardFeeder,
  IRewardFeederInterface,
} from "../../../contracts/interfaces/IRewardFeeder";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "percentage",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "oneHundredPercent",
        type: "uint256",
      },
    ],
    name: "RewardFeeder_PercentageTooLarge",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
    ],
    name: "RewardFeeder_TierNotDefined",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
    ],
    name: "TierRewardsRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rewardAPY",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tierMultiplier",
        type: "uint256",
      },
    ],
    name: "TierRewardsSet",
    type: "event",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getRewardAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getRewardParams",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "rewardAPY",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tierMultiplier",
            type: "uint256",
          },
        ],
        internalType: "struct IRewardFeeder.RewardData",
        name: "params",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
    ],
    name: "removeTierRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tierLevel",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rewardAPY",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "tierMultiplier",
            type: "uint256",
          },
        ],
        internalType: "struct IRewardFeeder.RewardData",
        name: "params",
        type: "tuple",
      },
    ],
    name: "setTierRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class IRewardFeeder__factory {
  static readonly abi = _abi;
  static createInterface(): IRewardFeederInterface {
    return new Interface(_abi) as IRewardFeederInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): IRewardFeeder {
    return new Contract(address, _abi, runner) as unknown as IRewardFeeder;
  }
}
